import { Line, mixins } from "vue-chartjs";

export default {
  extends: Line,
  mixins: [mixins.reactiveProp],
  props: ["chartData", "stroke"],

  mounted() {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, this.options);
  },

  computed: {
    options() {
      return {
        title: {
          display: true,
          text: this.stroke
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              type: "time",
              /*time: {
                            format: Date
                            // round: 'day'
                        },*/
              scaleLabel: {
                display: true,
                labelString: "Date"
              }
            }
          ],
          yAxes: [
            {
              ticks: {
                userCallback: value => {
                  var n = new Date(0, 0);
                  n.setSeconds(+value * 60);
                  return n.toTimeString().slice(0, 8);
                }
              }
            }
          ]
        },
        tooltips: {
          enabled: true,
          callbacks: {
            label: tooltipItem => {
              var n = new Date(0, 0);
              n.setSeconds(+tooltipItem.yLabel * 60);
              //var temp = this.chartData.datasets[tooltipItem.datasetIndex];
              if (
                this.chartData.datasets[tooltipItem.datasetIndex].data[
                  tooltipItem.index
                ].comments == null
              )
                this.chartData.datasets[tooltipItem.datasetIndex].data[
                  tooltipItem.index
                ].comments = ".cl2";
              return (
                this.chartData.datasets[tooltipItem.datasetIndex].label +
                " " +
                this.chartData.datasets[tooltipItem.datasetIndex].data[
                  tooltipItem.index
                ].stroke +
                " - " +
                n.toTimeString().slice(0, 8) +
                "\n - " +
                this.chartData.datasets[tooltipItem.datasetIndex].data[
                  tooltipItem.index
                ].comments.replace(".cl2", "")
              );
            }
          }
        }
      };
    }
  }
};
